import React, { Component } from 'react';
import {Howl, Howler} from 'howler';
import './VideoPlayer.css';


class VideoPlayer extends Component {

  constructor(props) {

    super(props);

    
    this.p1 = false;
    this.p2 = false;

    this.p1_load_ok = false;
    this.p2_load_ok = false;
    
    this.state = {    
      currentPlay : 1,
      isLoading1 : false,
      isLoading2 : false
      
    }        

   this.loop_sound = false;
 
  }


  player_error = ( e ) =>
  {
    let msg="";
    switch (e.target.error.code) {
      case e.target.error.MEDIA_ERR_ABORTED:
        msg = 'You aborted the video playback.';
        break;
      case e.target.error.MEDIA_ERR_NETWORK:
        msg = 'A network error caused the video download to fail part-way.';
        break;
      case e.target.error.MEDIA_ERR_DECODE:
        msg = 'The video playback was aborted due to a corruption problem or because the video used features your browser did not support.';
        break;
      case e.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
        msg = 'The video could not be loaded, either because the server or network failed or because the format is not supported.';
        break;
      default:
        msg = 'An unknown error occurred.';
        break;
    }
    this.props.logFn("VideoPlayer:failed_video: error (video)::"+msg+" >>> ERROR");      

  }


  player1_load_ok = (e) =>
  {
    this.props.logFn("VideoPlayer::player1_load_ok() start playing P1, pause P2"/*, e*/);
    if(!this.p1_load_ok)
    {
      this.setState( { isLoading1 : false });

      this.p1_load_ok = true;
      this.p1.play(); 
      this.p2.pause(); // stop previous video
      //this.setState( { style1 : { zIndex : 0 }, style2 : { zIndex : -1 }  });
      this.p1.style.zIndex = 0;
      this.p2.style.zIndex = -1;

      if(this.props.onReadyVideo) this.props.onReadyVideo();
    }
  }

  player2_load_ok = (e) =>
  {
     this.props.logFn("VideoPlayer::player2_load_ok() start playing P2, pause P1"/*, e*/);
     if(!this.p2_load_ok)
     {
      this.setState( { isLoading2 : false });

      this.p2_load_ok = true; 
      this.p2.play(); 
      this.p1.pause(); // stop previous video
//     this.setState( { style1 : { zIndex : -1 }, style2 : { zIndex : 0 }  });
      this.p1.style.zIndex = -1;
      this.p2.style.zIndex = 0;

      if(this.props.onReadyVideo) this.props.onReadyVideo();
     }
}  

  player1_ended = (e) =>
  {
    this.props.logFn("VideoPlayer:player1_ended()");      
    this.p1_load_ok = false;
    if(this.props.onEndVideo)  this.props.onEndVideo(this.props.src);     
  }   
  player2_ended = (e) =>
  {
    this.props.logFn("VideoPlayer:player2_ended()");      
    this.p2_load_ok = false;
    if(this.props.onEndVideo)  this.props.onEndVideo(this.props.src);     
  }

  componentDidMount() 
  {
    this.props.logFn("VideoPlayer::componentDidMount(): start Loading"+ this.props.src+" on P1,"+this.props.loop);
    if(this.p1)
    {
      this.p1.addEventListener("error", this.player_error);
      //this.p1.addEventListener("canplaythrough", this.player1_load_ok);
      this.p1.addEventListener("canplaythrough", this.player1_load_ok);
      this.p1.addEventListener("ended",   this.player1_ended);

      /* first video */

      if(this.props.src)
      {      
        this.p1.src = this.props.src; 
        this.p1.load();   // nécessaire pour déclencher le canplaythrough sur iOS;
        if(this.props.loop)     this.p1.loop = true;
        else                    this.p1.loop = false;    
        this.setState( { isLoading1 : true });
      }

    }
    if(this.p2)
    { 
      this.p2.addEventListener("error", this.player_error);
      this.p2.addEventListener("canplaythrough", this.player2_load_ok);
      this.p2.addEventListener("ended",   this.player2_ended);
    }

  }  

  componentWillUnmount()
  {
    this.props.logFn("VideoPlayer::componentWillUnmount()");
    if(this.p1)
    {
      this.p1.removeEventListener("error", this.player_error);
      this.p1.removeEventListener("canplaythrough", this.player1_load_ok);
      this.p1.removeEventListener("ended",   this.player1_ended);
      this.p1 = false;
    }
    if(this.p2)
    {    
      this.p2.removeEventListener("error", this.player_error);
      this.p2.removeEventListener("canplaythrough", this.player2_load_ok);
      this.p2.removeEventListener("ended",   this.player2_ended);    
      this.p2 = false;
    }
  }

  shouldComponentUpdate(nextProps, nextState)
  {
     // this.props.logFn("VideoPlayer::shouldComponentUpdate: "+ nextProps.src+ ","+ nextProps.loop);

      const { menuOpen, src, onEndVideo, onReadyVideo, loop } = nextProps;

      /* gère le menu et la pause */

      if( ( this.props.menuOpen !== menuOpen) && (nextProps.menuOpen != undefined) )
      { 
        if(menuOpen)
        {
          this.props.logFn("VideoPlayer::shouldComponentUpdate : enter menu/poi, pause video");

          this.mute_audio_loop(true);
          this.pause_video();  // pause
          //return false;
        }else  
        {
          this.props.logFn("VideoPlayer::shouldComponentUpdate : exit menu/poi, replay video");

          this.mute_audio_loop(false);
          // attention buggogen, on ne devrait rejouer la vidéo que si on est pas sur un interactif sans vidéo de bkg :
          // regler en supprimant les onEndVideo dans le App au dessus
          // et aussi en vérifiant qu'on est pas à la fin d'une video (end), pour ne pas la relancer
          if( ( ( this.state.currentPlay == 1) && this.p1_load_ok) ||
              (  ( this.state.currentPlay == 2) && this.p2_load_ok) )
            this.restart_video();  // play
          //return false;
        }
      }

      if( (nextProps.src != this.props.src) && (nextProps.src != false) )
      { 
        //this.isPlayer1 = !this.isPlayer1;
       // this.old_src = this.props.src
//        this.setState({ isPlayer1 : !this.state.isPlayer1, old_src: this.props.src});
        // la source à changée 

        if (this.state.currentPlay === 1) 
        {  
          this.props.logFn("VideoPlayer:shouldComponentUpdate : Start loading "+nextProps.src+" on P2, with loop:"+nextProps.loop);
          this.p2.src = nextProps.src;
          this.p2.load();    // nécessaire pour déclencher le canplaythrough sur iOS;
          this.p2_load_ok = false;
          if(nextProps.loop) this.p2.loop = true;
          else               this.p2.loop = false;

          this.setState( { isLoading2 : true, currentPlay : 2 });

          if(nextProps.loop)  this.play_audio_loop(this.p2.src)
          else                this.stop_audio_loop()              

        }
        else{ // (this.currentPlay == 2)
          this.props.logFn("VideoPlayer:shouldComponentUpdate: Start loading "+nextProps.src+") on P1, with loop:"+nextProps.loop);
          this.p1.src = nextProps.src;
          this.p1.load();   // nécessaire pour déclencher le canplaythrough sur iOS;
          this.p1_load_ok = false;
          if(nextProps.loop) this.p1.loop = true;
          else               this.p1.loop = false;

          this.setState( { isLoading1 : true, currentPlay : 1 });

          if(nextProps.loop)  this.play_audio_loop(this.p1.src)
          else                this.stop_audio_loop()            
        }
    
        
      }
      return true;
  }


  pause_video = () =>
  {
    this.props.logFn("VideoPlayer:pause_video()");

    /* FIXME : peut-être un cas de bug si on fait une pause pendant un swap de video p1<>p2 */

    let p = this.p2;
    if (this.state.currentPlay === 1) p = this.p1;
    p.pause();

  }

  restart_video = () =>
  {
    this.props.logFn("VideoPlayer:restart_video()");

    /* FIXME : peut-être un cas de bug si on fait une pause pendant un swap de video p1<>p2 */

    //if(! this.isPlaying) return;

    let p = this.p2;
    if (this.state.currentPlay === 1) p = this.p1;
    p.play();

  }


  /* hewler audio */

  play_audio_loop = ( video_file ) =>
  {

    const audio_file = video_file.replace('.mp4','.mp3');
    this.props.logFn("VideoPlayer:play_audio_loop() : "+audio_file);

    if(this.loop_sound)  // il y avait déja un son
    {
      this.loop_sound.unload();
      this.loop_sound = false;
    }

    this.loop_sound = new Howl({
      src: audio_file,
      autoplay: true,
      loop: true,
    });      
    //this.loop_sound.play();
  }

  mute_audio_loop = ( b ) =>
  {
    this.props.logFn("VideoPlayer:mute_audio_loop() : "+b);

    if(this.loop_sound)
    {
      this.loop_sound.mute( b );
    }
  }

  stop_audio_loop = () =>
  {
    this.props.logFn("VideoPlayer:stop_audio_loop() : ");

    if(this.loop_sound)
    {
      this.loop_sound.unload(); // this.loop_sound.stop() est appelé par le unload()
      this.loop_sound = undefined;
    }
  }

  /* --- */

  render() {

    const { currentPlay, isLoading1, isLoading2 } = this.state;

    let styleDebug1 = {};
    let styleDebug2 = {};
    // FOR DEBUGGING 
    /*E:\WORK_MGD\PROD\180ans\App\src\images
    if(currentPlay == 1)
    {
      styleDebug1={ borderColor:'#FF0', borderWidth:4, borderStyle:'solid' };
    }else
    {
      styleDebug2={ borderColor:'#FF0', borderWidth:4, borderStyle:'solid' };
    }
  */
    return (
      <div className="VideoPlayer" >
        <video className="videodiv debug1"  style={ styleDebug1 }  ref={ (node)  => { this.p1 = node; } } playsInline="playsInline" preload="auto"></video> 
        <video className="videodiv debug2"  style={ styleDebug2 }  ref={ (node)  => { this.p2 = node; } } playsInline="playsInline" preload="auto"></video> 
        { ( (isLoading1 && (currentPlay == 1) ) || (isLoading2 && (currentPlay == 2) ) ) &&  <div className="videoLoader"></div> }
      </div>

    );
  }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/VideoPlayer.js